import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Analytic Byte</h3>
          <p>To be a trusted global partner delivering innovative engineering, 
            technology, and manpower solutions that empower organizations to achieve 
            excellence, accelerate growth, and shape a smarter, more efficient future.</p>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/services">Services</Link></li>
          </ul>
        </div>
        
      </div>
      
      <div className="copyright">
        <p>&copy; 2015 - {new Date().getFullYear()} Analytic Byte. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;